module.exports = __webpack_public_path__ + "static/media/4-10.5742085f.mp3";